import styled from '@emotion/styled';
import { Css, Responsive } from '../../../ui';

export const QuickLinksColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(8)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(16)};
	}
`;
